export default "__VITE_ASSET__JMbukKLI__"